import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-add\"><defs><style>#icon-add .cls-1{fill:'';}</style></defs><title>icon_add</title><path class=\"cls-1\" d=\"M7,0a7,7,0,1,0,7,7A7,7,0,0,0,7,0ZM7,13a6,6,0,1,1,6-6A6,6,0,0,1,7,13Z\" transform=\"translate(0 0)\" /><path class=\"cls-1\" d=\"M10.5,6.5h-3v-3a.5.5,0,0,0-1,0v3h-3a.5.5,0,0,0,0,1h3v3a.5.5,0,0,0,1,0v-3h3a.5.5,0,0,0,0-1Z\" transform=\"translate(0 0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol